import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminAttorneyPasscodesPage = () => {
  return (
    <>
      <Helmet>
        <title>Attorneys Passcodes - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
